import { render, staticRenderFns } from "./gift_set.vue?vue&type=template&id=4e27291a&scoped=true"
import script from "./gift_set.vue?vue&type=script&lang=ts"
export * from "./gift_set.vue?vue&type=script&lang=ts"
import style0 from "./gift_set.vue?vue&type=style&index=0&id=4e27291a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e27291a",
  null
  
)

export default component.exports